import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-epmall/brand/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-epmall/brand/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-epmall/brand/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-epmall/brand/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-epmall/brand/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-epmall/brand/submit',
    method: 'post',
    data: row
  })
}

//修改状态
export const updateBrandStates = (id) => {
  return request({
    url: '/api/park-epmall/brand/updatebrand/' + id,
    method: 'post',
    data: {}
  })
}

